import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { BadgeCategories } from './badge.types';
import { ThemeSelectors, TypeMini } from '@at/design-system-foundation';
export var getBadgeBackgroundAndColorSelectors = function (category) {
    switch (category) {
        case BadgeCategories.custom:
        case BadgeCategories.default:
            return {
                backgroundSelector: ThemeSelectors.getLightGrey,
                colorSelector: ThemeSelectors.getTitleColor,
            };
        case BadgeCategories.saving:
            return {
                backgroundSelector: ThemeSelectors.getATRed,
                colorSelector: ThemeSelectors.getWhite,
            };
        case BadgeCategories.highlight:
            return {
                backgroundSelector: ThemeSelectors.getColorDecorBgSurface,
                colorSelector: ThemeSelectors.getTitleColor,
            };
        case BadgeCategories.writeOff:
            return {
                backgroundSelector: ThemeSelectors.getYellow,
                colorSelector: ThemeSelectors.getTitleColor,
            };
        case BadgeCategories.priceIndicatorFair:
            return {
                backgroundSelector: ThemeSelectors.getPriceIndicatorFairBackgroundColor,
                colorSelector: ThemeSelectors.getPriceIndicatorFairColor,
            };
        case BadgeCategories.priceIndicatorGood:
            return {
                backgroundSelector: ThemeSelectors.getGreen,
                colorSelector: ThemeSelectors.getWhite,
            };
        case BadgeCategories.priceIndicatorGreat:
            return {
                backgroundSelector: ThemeSelectors.getLightGreen,
                colorSelector: ThemeSelectors.getTitleColor,
            };
        case BadgeCategories.priceIndicatorHigh:
            return {
                backgroundSelector: ThemeSelectors.getPriceIndicatorHighBackgroundColor,
                customColor: '#FF9A7A',
                colorSelector: ThemeSelectors.getTitleColor,
            };
        case BadgeCategories.priceIndicatorLow:
            return {
                backgroundSelector: ThemeSelectors.getDarkGrey,
                colorSelector: ThemeSelectors.getTitleColor,
            };
        case BadgeCategories.tags:
            return {
                backgroundSelector: ThemeSelectors.getTitleColor,
                colorSelector: ThemeSelectors.getWhite,
            };
        case BadgeCategories.pdpSpecs:
            return {
                backgroundSelector: ThemeSelectors.getColorDecorBgSurfaceSoft,
                colorSelector: ThemeSelectors.getTitleColor,
            };
        case BadgeCategories.onContent:
            return {
                backgroundSelector: ThemeSelectors.getWhite,
                colorSelector: ThemeSelectors.getTitleColor,
            };
        default:
            return {
                backgroundSelector: function () { return undefined; },
                colorSelector: function () { return undefined; },
            };
    }
};
var handleBoxShadow = function (theme, category) {
    switch (category) {
        case BadgeCategories.onContent:
            return ThemeSelectors.getShadowFive(theme);
        default:
            return 'none';
    }
};
export var Badge = styled(TypeMini)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    display: flex;\n    font-variation-settings: 'wght' 500;\n    height: 1.5rem;\n    justify-content: center;\n    line-height: 1;\n    padding: ", ";\n"], ["\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    display: flex;\n    font-variation-settings: 'wght' 500;\n    height: 1.5rem;\n    justify-content: center;\n    line-height: 1;\n    padding: ", ";\n"])), function (_a) {
    var theme = _a.theme, backgroundSelector = _a.backgroundSelector, customColor = _a.customColor;
    return customColor || backgroundSelector(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
}, function (_a) {
    var theme = _a.theme, category = _a.category;
    return handleBoxShadow(theme, category);
}, function (_a) {
    var theme = _a.theme, colorSelector = _a.colorSelector;
    return colorSelector(theme);
}, function (_a) {
    var theme = _a.theme;
    return "".concat(ThemeSelectors.getGroupOneSpacing(theme), " ").concat(ThemeSelectors.getGroupTwoSpacing(theme));
});
var templateObject_1;
